export const numberOfWaste = {
    amountOfWaste: Math.floor(Math.random() * (30 - 25 + 1) + 25)
};